export default __webpack_public_path__ + "static/media/Screen Shot 2022-08-26 at 9.30.42 AM.91267094.png";